<template>
	<div class="container" style="padding-top: 70px;width: 1280px;">
		<div class="one" style="background-color: rgba(255, 255, 255, 1);">
			<div class="xinxi"><span>学生姓名:</span><a>{{userInfo.userName}}</a></div>
			<div class="xinxi"><span>省市:</span><a>{{areaInfo.areaFullName}}</a></div>
			<div class="xinxi"><span>科类:</span><a>{{SUBJECTTYPEOBJ[scoreInfo.scoreSubject]}}</a></div>
			<div class="xinxi"><span>批次:</span><a>{{batch?batch.provincialBatch:'--'}}</a></div>
			<div class="xinxi"><span>分数:</span><a>{{scoreInfo.score}}分</a></div>
			<div class="xinxi"><span>位次:</span><a>{{scoreInfo.scoreRank}}</a></div>
			<div class="xinxi"><span>线差:</span><a>{{batch?Math.round(scoreInfo.score-batch.provincialScore):"--"}}</a></div>
			<div class="xinxi" @click="update" style="margin-right: 50px;"><img src="../../src/assets/img/bianji.png" alt=""><a>编辑</a></div>
		</div>
	</div>
</template>
<script>
	export default {
		props: [],
		components: {

		},
		data() {
			return {
        batch: this.$utils.getlocalStorage("userZhiYuanBatch"),
        areaInfo: this.$utils.getlocalStorage("areaInfo"),
        scoreInfo: this.$utils.getlocalStorage("scoreInfo"),
        userInfo: this.$utils.getlocalStorage("userInfo"),
        SUBJECTTYPEOBJ: this.$utils.getlocalStorage("SUBJECTTYPEOBJ"),
      };
		},
		computed: {},
		methods: {
      getdata(){
        this.batch = this.$utils.getlocalStorage("userZhiYuanBatch")
        this.areaInfo = this.$utils.getlocalStorage("areaInfo")
        this.scoreInfo = this.$utils.getlocalStorage("scoreInfo")
        this.userInfo = this.$utils.getlocalStorage("userInfo")
      },
      update() {
        if(this.userInfo.userRole == 3||this.userInfo.userRole == 2){
           this.$router.push('/grzx_wdxs')
        } else {
          this.$router.push('/grzx_wdfs')
        }

      }
    },
		mounted() {
      this.getdata()
    },
	};
</script>
<style scoped>
	.one {
		margin-top: 20px;
		justify-content: space-between;
		width: 100%;
		height: 50px;
		background: rgba(255, 255, 255, 0.39);
		box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.16);
		border-radius: 5px;
		display: flex;
		padding-left: 20px;
	}

	.one span {
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #666;
	}

	.one span,
	.xinxi img {
		margin-right: 8px;
	}
	/* 设置个别宽度不是以下不是此范围的样式 */
	@media (min-width: 1400px) {
		.container {
			width: 1500px;
		}
	}

	.xinxi {
		line-height: 50px;
		margin-right: 0px;
	}

	.xinxi a {
		color: #29A7E1;
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 500;
	}

	@media (max-width: 750px) {
		.one {
			overflow: auto;
			margin-top: 20px;
			margin-bottom: 20px;
		}

		.one span {
			flex-shrink: 0;
		}

		.xinxi {
			flex-shrink: 0;
		}
	}


	@media (max-width: 980px) {
		.one {
			overflow: auto;
			margin-top: 20px;
			margin-bottom: 20px;
		}

		.one span {
			flex-shrink: 0;
		}

		.xinxi {
			flex-shrink: 0;
		}
	}

	@media (max-width: 1400px) {
		.one {
			/* overflow: auto; */
			margin-top: 20px;
			/* margin-bottom: 20px; */
		}

		.one span {
			flex-shrink: 0;
		}

		.xinxi {
			flex-shrink: 0;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/vMassage.vue